<template>
  <div style="height: 100%; background: #F2F2F6">
         <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'ProductList' }">产品列表</el-breadcrumb-item>
          <el-breadcrumb-item>产品编辑</el-breadcrumb-item>
        </el-breadcrumb>
    <el-row style="padding: 30px">
      <el-col :span="24" >
        <el-form
          :model="product"
          :rules="rules"
          ref="customerForm"
          label-width="150px"
          label-position="right"
          size="mini"
        >
        <el-row style="color:#666666;font-size:16px ">
          <span>基础信息</span>
        </el-row>
          <el-divider></el-divider>
           <el-form-item label="名称" prop="title">
            <el-input v-model="product.title" maxlength="120" size="small"></el-input>
          </el-form-item>
          <el-form-item label="主题" prop="theme_ids">
            <el-select
            filterable
         size="small"
          v-model="product.theme_ids">
          <el-option v-for="item in classTable" :label="item.name" :value="item.innerid" :key="item.innerid" ></el-option>
          </el-select>
          </el-form-item>

          <el-form-item label="颗粒数" prop="pcs">
            <el-input-number v-model="product.pcs" size="small" :min="1" :max="15000" ></el-input-number>
          </el-form-item>
          <el-form-item label="封面" prop="cover">
           <el-image  v-if="product.cover" :src="product.cover" class="avatar"></el-image>
          <el-button  v-if ="product.cover" type="text" @click="product.cover=''">删除封面</el-button>
          <el-button  type="text" @click="showResource(1)">选择图片</el-button>
          </el-form-item>
       <el-form-item label="轮播图" prop="slider_image">
     <el-row v-if ="product.slider_image">
      <el-col :span="3" v-if="item" v-for="item in product.slider_image.split(',')" :key="item">
      <el-image style="display:flex"  :src="item" class="avatar"></el-image>
      </el-col>
     </el-row>
     
          <el-button  v-if ="product.slider_image" type="text" @click="product.slider_image=''">删除图片</el-button>
          <el-button  type="text" @click="showResource(2)">选择图片</el-button>
          </el-form-item>
            <el-form-item label="推荐年龄" prop="age_range">
            <el-select
            filterable
         size="small"
          v-model="product.age_range">
          <el-option v-for="item in ageTable" :label="item.name" :value="item.innerid" :key="item.innerid" ></el-option>
          </el-select>
          </el-form-item>
           <el-row style="color:#666666;font-size:16px ">
          <span>存量信息</span>
        </el-row>
            <el-divider></el-divider>
            <el-form-item label="上架" prop="status">
            <el-switch
    v-model="product.status"
    active-color="#13ce66"
    inactive-color="#ff4949"
    :active-value="1"
    :inactive-value="2">
  </el-switch>
          </el-form-item>
             <el-form-item label="库存" prop="stock">
            <el-input-number v-model="product.stock" size="small" :min="0"  ></el-input-number>
          </el-form-item>
           <el-form-item label="销量" prop="pcs">
            <el-input-number v-model="product.sale" size="small" :min="0"  ></el-input-number>
          </el-form-item>
           <el-row style="color:#666666;font-size:16px ">
          <span>价格租期</span>
        </el-row>
            <el-divider></el-divider>
            <el-form-item label="日租最低价" prop="price">
            <el-input-number v-model="product.price" size="small" :step="0.1" :min="1" :max="15000" ></el-input-number>
          </el-form-item>
          <el-form-item label="零售价" prop="retail_price">
            <el-input-number v-model="product.retail_price" size="small" :step="0.1" :min="1" :max="15000" ></el-input-number>
          </el-form-item>
           <el-form-item label="押金" prop="deposit">
            <el-input-number v-model="product.deposit" size="small" :step="0.1" :min="1" :max="15000" ></el-input-number>
          </el-form-item>
          <el-form-item label="租期" style="color:#666">
            <el-checkbox-group v-model="checkboxGroup" size="small">
      <el-checkbox-button v-for="item in tenancyTable" :label="item.days+''"  :key="item.days">{{item.title}}</el-checkbox-button>
    </el-checkbox-group>
          <el-row style="margin-top:5px">
          <el-col :span="4">租期</el-col>
          <el-col :span="4">价格</el-col>
          </el-row>
          <el-row v-for="item in prices" :key="item.days" style="margin-top:5px">
          <el-col :span="4">{{item.days}}天</el-col>
          <el-col :span="4"><el-input-number v-model="item.price" size="small" :step="0.01" :min="1" :max="15000" ></el-input-number></el-col>
          </el-row>
          </el-form-item>
            <el-row style="color:#666666;font-size:16px ">
          <span>其他</span>
        </el-row>
            <el-divider></el-divider>
              <el-form-item label="服务内容" prop="service_explain">
            <el-input v-model="product.service_explain" size="small"  ></el-input>
          </el-form-item>
           <el-form-item label="商品详情" prop="details">
            <vue-editor id="editor" ref="editor" style="color:#666"
   v-model="product.details"  />
          </el-form-item>
             <el-divider></el-divider>
          <el-form-item>
            <el-button type="primary" @click="saveProduct()">保存</el-button>
            <el-button @click="back()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
     <el-dialog title="图片选择" height="800" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
    <el-row >
      <el-col :span="6" style="text-align:right">
        <el-input v-model="where.name" maxlength="120" size="mini" placeholder="文件名"></el-input>
      </el-col>
       <el-col :span="18" style="text-align:right">
        <el-button size="mini" type="primary" @click="searchResource()">{{$t("base.search")}}</el-button>
        <el-upload
            style="text-align:left;width:80px; display:inline;"
              class="upload-demo"
              name="upload"
              action="http://resource.ddyuewu.com/resource/upload"
              :show-file-list="false"
              multiple
              :limit="5"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload">
              <el-button size="mini" type="primary">点击上传</el-button>
          </el-upload>
      </el-col>
  </el-row>
   <el-divider></el-divider>
        <el-table
          :data="resourceTable"
          ref="table"
          stripe
          height="300"
          border
          style=" margin:0;width: 100%;border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', 'text-align': 'center' }"
        >
        <el-table-column
        fixed
        width="50">
      <template slot-scope="scope">
        <el-checkbox v-model="scope.row.checked" @change="$forceUpdate()"></el-checkbox>
      </template>
    </el-table-column>
          <el-table-column
            type="index"
            label=""
            width="75"
            :index="indexMethod"
          ></el-table-column>
          <el-table-column prop="original_filename" label="文件名">
          </el-table-column>
           <el-table-column prop="storage_uri" label="图片">
            <template slot-scope="scope">
               <el-image
    style="width: 40px; height: 40px"
    :src="scope.row.storage_uri" >
  </el-image>
            </template>
           </el-table-column>
        </el-table>

    <el-row style="height:40px">
        <el-pagination
          background
          :page-sizes="[10, 15]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 0.625rem;margin-bottom:10px"
        >
        </el-pagination>
    </el-row>
  <div slot="footer" class="dialog-footer">
    <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
    <el-button size="mini" type="primary" @click="selectResouce()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'CreateUser',
  data () {
    return {
      product: {
        title: '',
        theme_ids: '',
        pcs: null,
        cover: '',
        slider_image: '',
        age_range: null,
        sale: 0,
        stock: 0,
        status: 2,
        price: 0,
        retail_price: 0,
        deposit:0,
        lease_term: '[]',
        service_explain:'部分包邮 | 线下自提',
        details:''
      },
      rules: {
        title: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        theme_ids: [{ required: true, message: '请选择主题', trigger: 'change' }],
        age_range: [{ required: true, message: '请选择推荐年龄', trigger: 'change' }]
      },
      dialogFormVisible: false,
      resourceTable: [],
      ageTable: [],
      classTable: [],
      tenancyTable: [],
      pageset: {
        size: 10,
        index: 1
      },
      totalsize: 0,
      where: {
        name: ''
      },
      resourceReturn:null,
      checkboxGroup:[],
      prices:[]
    }
  },
  watch:{
    checkboxGroup: function (val){
      let newlist=[]
      val.forEach(item=>{
        let exist=this.prices.find(i=>i.days==item)
        if(exist){
          newlist.push(exist)
        }else{
          newlist.push({days:item+'',price:0})
        }
      })
      this.prices=newlist.sort((a,b)=>a.days-b.days)
    }
  },
  mounted: function () {
    let user = window.localStorage.getItem('customer')
    if (user) {
     this.$nextTick(() => {
      const quill = this.$refs.editor.quill
      // 获取工具栏 DOM
      const toolbar = quill.getModule('toolbar')
      // 查找工具栏容器
      const toolbarContainer = quill.container.previousSibling
      // 创建自定义按钮
      const customBtn = document.createElement('button')
      customBtn.innerHTML = '<i class="el-icon-picture"></i>'
      customBtn.type = 'button'
      customBtn.className = 'ql-customButton'
      customBtn.onclick = () => {
        // 你的自定义逻辑，比如弹窗
        console.log('自定义按钮点击了1')
        this.showResource(3)
      }
      // 插入到工具栏
      toolbarContainer.appendChild(customBtn)
      // Quill事件绑定（可选，已在toolbar.addHandler中绑定）
      toolbar.addHandler('customButton', () => {
         console.log('自定义按钮点击了2')
        this.showResource(3)
      })
    })
      Vue.axios
        .post('/product/params/all', {
          category: 'class'
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.classTable = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
        Vue.axios
        .post('/product/params/all', {
          category: 'age'
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.ageTable = res.data.msgbody
            this.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
         Vue.axios
        .post('/product/tenancy/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tenancyTable = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
        if(this.$route.params.innerid&&this.$route.params.innerid!='-1'){
           Vue.axios
        .post('/product/query', {innerid:this.$route.params.innerid})
        .then((res) => {
          if (res.data.errcode == 0) {
            this.product = res.data.msgbody[0]
            this.prices=JSON.parse(this.product.lease_term||'[]')
            this.checkboxGroup=this.prices.map(item=>item.days+'')
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
        }
          
    } else {
      this.$message({
        message: '无登录信息，请重新登录',
        type: 'warning'
      })
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    showResource(type){
      this.resourceReturn=type
      this.searchResource()
      this.dialogFormVisible=true
    },
    indexMethod (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.searchResource()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.searchResource()
    },
    handleAvatarSuccess (response) {
      this.searchResource()
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    createUser () {
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          var self = this
          // debugger;
          self.customer.password = hex_md5(self.customer.orgpassword)
          self.customer.orgpassword = ''
          self.customer.password2 = ''
          Vue.axios
            .post('/factory/add',
              self.customer
            )
            .then((res) => {
              if (res.data.errcode == 0) {
                self.$message({
                  message: '厂家创建成功',
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || '发生未知错误，请联系相关人员查看',
                  type: 'error'
                })
                self.disabled = false
              }
            })
        } else {
          return false
        }
      })
    },
    searchResource () {
      var self = this
      Vue.axios
        .post('/resource/list', {
          where: self.where,
          pageset: self.pageset
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            res.data.msgbody.forEach(item => { item.checked = false })
            self.resourceTable = res.data.msgbody
            self.$forceUpdate()
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
      Vue.axios
        .post('/resource/list/count', {
          where: self.where
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t('base.systemError'),
              type: 'error'
            })
          }
        })
    },
    back () {
      this.$router.back()
    },
    selectResouce () {
      const pic=this.resourceTable.filter(item => item.checked)
      if(pic.length>0){
        if(this.resourceReturn==1){
          this.product.cover=pic[0].storage_uri
        }else if(this.resourceReturn==2){
          this.product.slider_image=pic.map(item=>item.storage_uri).join(',')
        }else if(this.resourceReturn==3){
          const quill = this.$refs.editor.quill
          pic.forEach(item=>{
            const range = quill.getSelection()
            const index = range ? range.index : quill.getLength()
            quill.insertEmbed(index, 'image', item.storage_uri)
          })
        }
        this.$forceUpdate()
      }
      this.dialogFormVisible=false
    },
    saveProduct(){
      this.product.lease_term=JSON.stringify(this.prices)
      this.$refs.customerForm.validate((valid) => {
        if (valid) {
          let url = '/product/add'
          if( this.product.innerid) {
            url = '/product/edit'
          }
          Vue.axios
            .post(url, this.product)
            .then((res) => {
              if (res.data.errcode === 0) {
                this.$message({
                  showClose: true,
                  message: this.$t('base.saveSuccess'),
                  type: 'success'
                })
                this.$router.back()
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.errmsg || this.$t('base.systemError'),
                  type: 'error'
                })
              }
            })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.ql-customButton {
  border: none;
  background: #409EFF;
  margin-left: 8px;
  padding: 0 12px;
  border-radius: 4px;
  cursor: pointer;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .el-upload-list--picture-card .el-upload-list__item {
     width: 100px;
  height: 100px;
    line-height: 100px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
   width: 100px;
  height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
   width: 100px;
  height: 100px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Product/EditProduct.vue